export const PackageName_tsShortUrl = 'ts-short-url';
export * from "./_entity/short-url/index.js";
//# sourceMappingURL=index.js.map